import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'
import { strVal } from '../../../modules/Utils'
import { get } from 'lodash'
import StandardType from '../../../elements/Select/StandardType'

const { TextArea } = Input

class StandardForm extends Component {
  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { standard } = this.props

    return (
      <Form layout="horizontal">
        <Row>
          <Col span={12}>
            <Form.Item label="Name" {...formItemLayoutRow}>
              {getFieldDecorator('name', {
                initialValue: strVal(standard, 'name'),
                rules: [{ required: true, message: "Name can't be empty " }],
              })(<Input placeholder="Name" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Status" {...formItemLayoutRow}>
              {getFieldDecorator('status', {
                initialValue: get(standard, 'status'),
                rules: [
                  {
                    required: true,
                    message: "status can't be empty ",
                  },
                ],
              })(<StandardType />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Description" {...formItemLayoutRow}>
              {getFieldDecorator('desc', {
                initialValue: get(standard, 'desc'),
              })(<TextArea placeholder="Description" rows={4} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(StandardForm)
